import React, { useState } from 'react';
import { Typewriter } from 'react-simple-typewriter';
import './Home.css';

const heroData = {
  text1: "Hi, I'm Ivy Makokha",
  words: [
    "A Passionate Software Developer",
    "Crafting Web & Mobile Apps",
    "with Clean and Scalable Code",
    "Empowering Through Tech & Innovation"
  ]
};

const Home = () => {
  const [playStatus, setPlayStatus] = useState(false);

  const toggleVideo = () => {
    setPlayStatus((prevStatus) => !prevStatus);
  };

  return (
    <div className="Home-container">
      {/* Video or Image */}
      {playStatus ? (
        <video className="background" autoPlay loop muted>
          <source src="/videos/video1.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <img
          src="/images/image1.png"
          className="background"
          alt="Background"
        />
      )}

      {/* Text over background */}
      <div className="hero-text">
        <h1>{heroData.text1}</h1>
        <h2 style={{ color: '#FF6600', fontWeight: 'bold' }}>
          <Typewriter
            words={heroData.words}
            loop={true}
            cursor
            cursorStyle="|"
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1500}
          />
        </h2>
      </div>

      {/* Toggle button */}
      <div className="toggle-button">
        <button onClick={toggleVideo}>
          {playStatus ? 'Show Image' : 'Play Video'}
        </button>
      </div>
    </div>
  );
};

export default Home;
